import { API_PATHS } from "./apiPaths";
import { axiosInstance } from "./axiosSetup";

export async function getJournals() {
    return axiosInstance.post(API_PATHS.PROXY_PATH, {
        path: API_PATHS.JOURNALS_LIST,
        method: "get"
    });
}

export async function updateJournalSubjects(journalSubjects) {
    return axiosInstance.post(API_PATHS.PROXY_PATH, {
        path: API_PATHS.JOURNAL_SUBJECTS_UPDATE,
        method: "patch",
        body: journalSubjects
    });
}

export async function getSubjects() {
    return axiosInstance.post(API_PATHS.PROXY_PATH, {
        path: API_PATHS.SUBJECTS_LIST,
        method: "get"
    });
}

export const getJournalRules = () => {
    return axiosInstance.get(API_PATHS.JOURNAL_RULES_LIST);
}

export const getJournalRulesVersions = () => {
    return axiosInstance.get(API_PATHS.JOURNAL_RULES_VERSIONS_LIST);
}

export const updateJournalRules = (rules) => {
    return axiosInstance.put(API_PATHS.UPDATE_JOURNAL_RULES, rules);
}

export const getNotificationRules = () => {
    return axiosInstance.get(API_PATHS.NOTIFICATION_RULES_LIST);
}

export const getNotificationRulesVersions = () => {
    return axiosInstance.get(API_PATHS.NOTIFICATION_RULES_VERSIONS_LIST);
}

export const updateNotificationRules = (rules) => {
    return axiosInstance.put(API_PATHS.UPDATE_NOTIFICATION_RULES, rules);
}

